export default __webpack_public_path__ + "static/media/a028-5.de13927e.svg";